import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="w-full relative z-10 bg-black border-t border-gray-800" data-id="element-248" data-mp="3gf958x4mo89h">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-249" data-mp="3ghc4m7ro7dqv">
        {/* Copyright */}
        <div className="text-center mt-4 pt-3 border-t border-gray-800" data-id="element-250" data-mp="32lrkxa44arie">
          <p className="text-gray-600 text-[10px] mb-1" data-id="element-251" data-mp="36q94b86kf2sn">
            &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-[10px] mb-1" data-id="element-252" data-mp="38qz78i6g9vx">
            Soporte:{' '}
            <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] transition-colors" data-id="element-253" data-mp="36d44znhyxod">
              support@truemarketer.com
            </a>
          </p>
          <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-254" data-mp="3qfjiuiukrhp6">
            <Link to="/terms" className="text-gray-500 hover:text-white transition-colors underline" data-id="element-255" data-mp="29xm06nd2d2ik">
              Términos
            </Link>
            <span className="text-gray-600" data-id="element-256" data-mp="3l9k1v1qqp380">|</span>
            <Link to="/privacy" className="text-gray-500 hover:text-white transition-colors underline" data-id="element-257" data-mp="3la29svmrl5vr">
              Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}